export default "__VITE_PUBLIC_ASSET__73cfaf91__"